import {Dispatch, FC, SetStateAction, createContext, useContext, useEffect, useState} from 'react';
import {WithChildren} from '../../helpers';

const SplashScreenContext = createContext<Dispatch<SetStateAction<number>> | undefined>(undefined);

const SplashScreenProvider: FC<WithChildren> = ({children}) => {
	const [count, setCount] = useState(0);
	const visible = count > 0;

	useEffect(() => {
		const splashScreen = document.getElementById('splash-screen');

		// Show SplashScreen
		if (splashScreen && visible) {
			splashScreen.classList.remove('hidden');

			return () => {
				splashScreen.classList.add('hidden');
			};
		}

		// Hide SplashScreen
		let timeout: number;
		if (splashScreen && !visible) {
			timeout = window.setTimeout(() => {
				splashScreen.classList.add('hidden');
			}, 3000);
		}

		return () => {
			clearTimeout(timeout);
		};
	}, [visible]);

	return <SplashScreenContext.Provider value={setCount}>{children}</SplashScreenContext.Provider>;
};

const SplashScreen: FC<{visible?: boolean}> = ({visible = true}) => {
	const setCount = useContext(SplashScreenContext);

	useEffect(() => {
		if (!visible) {
			return;
		}

		if (setCount) {
			setCount((prev) => {
				return prev + 1;
			});
		}

		// eslint-disable-next-line consistent-return
		return () => {
			if (setCount) {
				setCount((prev) => {
					return prev - 1;
				});
			}
		};
	}, [setCount, visible]);

	return null;
};

export {SplashScreenProvider, SplashScreen};
